import React from "react";
import Navbar from "@/common/Navbar";
import AwsDashboard from "@/page-components/cost-explorer/aws/aws-cost-explorer.page";
import AzureDashboard from "@/page-components/cost-explorer/azure/azure-cost-explorer.page";

import LoginPage from "@/page-components/login/login.page";
import AllCloudRightSizing from "@/page-components/RightSizing/AllCloudRightSizing/AllCloudRightSizing";
import OnWork from "@/common/OnWork";
import AWSRightSizing from "@/page-components/RightSizing/AWSRightSizing/AWSRightSizing";
import AzureScreen from "@/page-components/RightSizing/AzureRightSizing/AzureScreen";
import {
  AuthGuard,
  AuthGuardWithRole,
} from "@/components/auth-guard/auth-guard.component";
import BudgetsPage from "@/page-components/budgets/Aws/budgets.page";
import SnapshotsMainPage from "@/page-components/snapshot/AllCloud/snapshot.page";
import SnapshotPage from "@/page-components/snapshot/Aws/snapShot.page";
import AzureBudgetPage from "@/page-components/budgets/Azure/azureBudget.page";
import LogoutPage from "@/page-components/logout/logout.page";
import AzurePage from "@/page-components/snapshot/Azure/azure.page";
import AllCloudsDashboard from "@/page-components/cost-explorer/all-clouds/all-clouds-cost-explorer.page";
import { Navigate } from "react-router-dom";
import AllCloudSaving from "@/page-components/savings/all-cloud-savings/all-cloud-saving.page";
import AWSCloudSaving from "@/page-components/savings/aws-cloud-savings/aws-cloud-saving.page";
import AzureCloudSaving from "@/page-components/savings/azure-cloud-savings/azure-cloud-saving.page";
import AwsIdleResource from "@/page-components/idle-resource/aws-idle-resource/aws-idle-resource.page";
import AzureIdleResource from "@/page-components/idle-resource/azure-idle-resource/azure-idle-resource.page";
import AllCloudIdleResource from "@/page-components/idle-resource/all-cloud-idle-resource/all-cloud-idle-resource.page";
import AdminLayout from "@/common/AdminLayout";
import Groups from "@/page-components/admin/groups/groups.page";
import Roles from "@/page-components/admin/roles/roles.page";
import Provisions from "@/page-components/admin/privileges/privileges.page";
import UserProfile from "@/page-components/admin/user profile/admin.page";
import { ROLES } from "@/App.context";
import { UsageDetailsComponent } from "@/page-components/cost-explorer/components/usage-details/usage.details.page";
import DetailedBudgetCost from "@/page-components/budgets/components/detailedList";
import AwsDetailedBudgetCost from "@/page-components/budgets/components/awsDetailsPage";
import Azure_RI_Screen from "@/page-components/RI-Capacity/azure-part/azure.screen";
import SearchComponents from "@/page-components/search-module/search-components.page";
import OnWorking from "@/common/OnWorking";
import AzureAiRecommendations from "@/page-components/ai-recommendations/azure-ai-recommend/azure-ai-recommend.page";
import AWSAiRecommendations from "@/page-components/ai-recommendations/aws-ai-recommend/aws-ai-recommendation.page";
import AzureBillingPage from "@/page-components/billing-credit/azure-biling-credit/azure-billing-credit.page";
import AzureRiScreenComponent from "@/page-components/RI-Capacity/azure-part/azure.screen";
import AwsCostPage from "@/page-components/cost-Recommendation/aws/awsCostPage";
import AzureCostPage from "@/page-components/cost-Recommendation/azure/azureCostPage";
import OnWorkallcloud from "@/common/OnWork.allcloud";
import AwsBillingPage from "@/page-components/billing-credit/aws-billing-credit/aws-billing-credit.page";
import AllCloudCostPage from "@/page-components/cost-Recommendation/all-cloud/all-cloudCostpage";
import AllCloudBillingPage from "@/page-components/billing-credit/all-cloud-credit/all-cloud-credit.page";
import AllCloudBudgetPage from "@/page-components/budgets/all-cloud/all-cloud-budget.page";
import GCPIdleResource from "@/page-components/idle-resource/gcp-idle-resource/gcp";
import GCPDashboard from "@/page-components/cost-explorer/gcp/gcp-cost-explorer.page";
import AwsCostAnomaly from "@/page-components/Cost-Anomaly/aws/aws-cost-anomaly.page";
import AzureCostAnomaly from "@/page-components/Cost-Anomaly/azure/azure-cost-anomaly.page";
import SnapshotPageGCP from "@/page-components/snapshot/GCP/gcp.page";
import GCPBudgetsPage from "@/page-components/budgets/Gcp/gcp.page";
import GCPCostAnomaly from "@/page-components/Cost-Anomaly/gcp/gcp-cost-anomaly.page";
import GcpBudgetPage from "@/page-components/budgets/Gcp/gcp.page";
import GCPBillingPage from "@/page-components/billing-credit/gcp-billing-credit/gcp-billing-credit.page";
import GCPCloudSaving from "@/page-components/savings/gcp-savings/gcp-cloud-saving.page";
import AzureRiUtilization from "@/page-components/ri-utilization/azure/azure-utilization.page";
import AWSUtilizationSection from "@/page-components/ri-utilization/aws/aws-utilization.page";
import AwsRiScreenComponent from "@/page-components/RightRecommendation/aws/aws-recommendation.page";
import AZureRiScreenComponent from "@/page-components/RightRecommendation/azure/azure-recommendation.page";
import AWSTagging from "@/page-components/taggings/aws-tagging/aws-tagging.page";
import AzureTagging from "@/page-components/taggings/azure-tagging/azure-tagging.page";
import GcpTagging from "@/page-components/taggings/gcp-tagging/gcp-tagging.page";
import AwsKubernates from "@/page-components/Kubernetes/awsKubernates/AwsKubernates";
import AzureKubernates from "@/page-components/Kubernetes/azureKubernates/AzureKubernates";
import AllCloudKubernates from "@/page-components/Kubernetes/allCloudKubernates/AllCloudKubernates";
import AllCloudReporting from "@/page-components/reporting/aws-reporting/aws-reporting.page";
import AWSReporting from "@/page-components/reporting/aws-reporting/aws-reporting.page";
import AzureReporting from "@/page-components/reporting/azure-reporting/azure-reporting.page";
import GCPReporting from "@/page-components/reporting/gcp-reporting/gcp-reporting.page";
import SettingPage from "@/page-components/admin/settings/settings.page";
import AllCloudRecommedationPage from "@/page-components/RightRecommendation/all-cloud/all-cloud-recommendation.page";
import AllCloudCostAnomaly from "@/page-components/Cost-Anomaly/all-cloud/all-cloud-cost-anomaly.page";

/**
 * @typedef RoutesData
 * @property {string} path
 * @property {boolean=} redirectToService
 * @property {React.ReactNode=} component
 * @property {React.ReactNode=} outlet
 * @property {React.ReactNode=} wrapper
 */

/** @type {RoutesData[]} */

const routesData = [
  {
    path: "/",
    component: <LoginPage />,
  },
  {
    path: "/logout",
    component: <LogoutPage />,
  },
  {
    path: "/all-clouds/dashboard",
    component: <Navbar />,
    outlet: <AllCloudsDashboard />,
    wrapper: AuthGuard,
    redirectToService: true,
    module: "dashboard",
  },
  {
    path: "/aws/dashboard",
    component: <Navbar />,
    outlet: <AwsDashboard />,
    wrapper: AuthGuard,
    redirectToService: true,
    module: "dashboard",
  },
  {
    path: "/azure/dashboard",
    component: <Navbar />,
    outlet: <AzureDashboard />,
    wrapper: AuthGuard,
    redirectToService: true,
    module: "dashboard",
  },

  {
    path: "/azure/dashboard/:BudgetName/:Id",
    component: <Navbar />,
    outlet: <AzureDashboard />,
    wrapper: AuthGuard,
    redirectToService: true,
    module: "dashboard",
  },

  {
    path: "/aws/dashboard/:BudgetName/:Id",
    component: <Navbar />,
    outlet: <AwsDashboard />,
    wrapper: AuthGuard,
    redirectToService: true,
    module: "dashboard",
  },

  {
    path: "/gcp/dashboard",
    component: <Navbar />,
    outlet: <GCPDashboard />,
    wrapper: AuthGuard,
    redirectToService: true,
    module: "dashboard",
  },

  {
    path: "/aws/idle-resource",
    component: <Navbar />,
    outlet: <AwsIdleResource />,
    wrapper: AuthGuard,
    redirectToService: true,
    module: "idle resource",
  },

  {
    path: "/azure/idle-resource",
    component: <Navbar />,
    outlet: <AzureIdleResource />,
    wrapper: AuthGuard,
    redirectToService: true,
    module: "idle resource",
  },
  {
    path: "/all-clouds/idle-resource",
    component: <Navbar />,
    outlet: <AllCloudIdleResource />,
    wrapper: AuthGuard,
    redirectToService: true,
    module: "idle resource",
  },
  {
    path: "/gcp/idle-resource",
    component: <Navbar />,
    outlet: <GCPIdleResource />,
    wrapper: AuthGuard,
    redirectToService: true,
    module: "idle resource",
  },
  {
    path: "/aws/budgets",
    component: <Navbar />,
    outlet: <BudgetsPage />,
    wrapper: AuthGuard,
    redirectToService: true,
    module: "budgets",
  },

  {
    path: "/azure/budgets",
    component: <Navbar />,
    outlet: <AzureBudgetPage />,
    wrapper: AuthGuard,
    redirectToService: true,
    module: "budgets",
  },
  {
    path: "/gcp/budgets",
    component: <Navbar />,
    outlet: <GcpBudgetPage />,
    // outlet: <OnWorking name="Budget" service="GCP" />,
    wrapper: AuthGuard,
    redirectToService: true,
    module: "budgets",
  },
  {
    path: "/all-clouds/budgets",
    component: <Navbar />,
    // outlet: <Navigate to="/aws/budgets" replace={true} />,
    outlet: <AllCloudBudgetPage />,
    wrapper: AuthGuard,
    redirectToService: true,
    module: "budgets",
  },
  {
    path: "/azure/budgets/:BudgetName/:Id",
    component: <Navbar />,
    outlet: <DetailedBudgetCost service={"azure"} />,
    wrapper: AuthGuard,
    redirectToService: true,
    module: "budgets",
  },

  {
    path: "/aws/budgets/:BudgetName/:Id",
    component: <Navbar />,
    outlet: <AwsDetailedBudgetCost service={"aws"} />,
    wrapper: AuthGuard,
    redirectToService: true,
    module: "budgets",
  },
  {
    path: "/gcp/budgets/:BudgetName/:Id",
    component: <Navbar />,
    outlet: <DetailedBudgetCost service={"gcp"} />,
    wrapper: AuthGuard,
    redirectToService: true,
    module: "budgets",
  },
  {
    path: "/all-clouds/recommendations",
    component: <Navbar />,
    outlet: <AllCloudCostPage service="all-cloud" />,
    wrapper: AuthGuard,
    redirectToService: true,
    module: "recommendations",
  },
  {
    path: "/aws/recommendations",
    component: <Navbar />,
    outlet: <AwsCostPage service="aws" />,
    wrapper: AuthGuard,
    redirectToService: true,
    module: "recommendations",
  },
  {
    path: "/azure/recommendations",
    component: <Navbar />,
    // outlet: <OnWorking name = "Cost-Recommendations"service="Azure" />,
    outlet: <AzureCostPage />,
    wrapper: AuthGuard,
    redirectToService: true,
    module: "recommendations",
  },
  {
    path: "/gcp/recommendations",
    component: <Navbar />,
    outlet: <OnWorking name="Cost-Recommendations" service="GCP" />,
    wrapper: AuthGuard,
    redirectToService: true,
    module: "recommendations",
  },

  {
    path: "/aws/vm-recommendations",
    component: <Navbar />,
    outlet: <AWSRightSizing service="aws" />,
    wrapper: AuthGuard,
    redirectToService: true,
  },
  {
    path: "/azure/vm-recommendations",
    component: <Navbar />,
    outlet: <AzureScreen />,
    wrapper: AuthGuard,
    redirectToService: true,
  },

  {
    path: "/all-clouds/vm-recommendations",
    component: <Navbar />,
    outlet: <AllCloudRightSizing />,
    wrapper: AuthGuard,
    redirectToService: true,
  },
  {
    path: "/gcp/vm-recommendations",
    component: <Navbar />,
    // outlet: <OnWork />,
    outlet: <OnWorking name="vm-recommendations" service="GCP" />,
    wrapper: AuthGuard,
    redirectToService: true,
  },

  {
    path: "/all-clouds/snapshots",
    component: <Navbar />,
    outlet: <SnapshotsMainPage />,
    wrapper: AuthGuard,
    redirectToService: true,
    module: "snapshots",
  },
  {
    path: "/aws/snapshots",
    component: <Navbar />,
    outlet: <SnapshotPage />,
    wrapper: AuthGuard,
    redirectToService: true,
    module: "snapshots",
  },
  {
    path: "/azure/snapshots",
    component: <Navbar />,
    outlet: <AzurePage />,
    wrapper: AuthGuard,
    redirectToService: true,
    module: "snapshots",
  },
  {
    path: "/gcp/snapshots",
    component: <Navbar />,
    outlet: <SnapshotPageGCP />,
    wrapper: AuthGuard,
    redirectToService: true,
    module: "snapshots",
  },
  {
    path: "/all-clouds/savings",
    component: <Navbar />,
    outlet: <AllCloudSaving />,
    wrapper: AuthGuard,
    redirectToService: true,
    module: "savings",
  },
  {
    path: "/aws/savings",
    component: <Navbar />,
    outlet: <AWSCloudSaving service="aws" />,
    wrapper: AuthGuard,
    redirectToService: true,
    module: "savings",
  },
  {
    path: "/azure/savings",
    component: <Navbar />,
    outlet: <AzureCloudSaving service="aws" />,
    wrapper: AuthGuard,
    redirectToService: true,
    module: "savings",
  },
  {
    path: "/gcp/savings",
    component: <Navbar />,
    outlet: <GCPCloudSaving />,
    wrapper: AuthGuard,
    redirectToService: true,
    module: "savings",
  },

  {
    path: "/aws/anomalies",
    component: <Navbar />,
    outlet: <AwsCostAnomaly />,
    wrapper: AuthGuard,
    redirectToService: true,
    module: "savings",
  },

  {
    path: "/azure/anomalies",
    component: <Navbar />,
    outlet: <AzureCostAnomaly />,
    wrapper: AuthGuard,
    redirectToService: true,
    module: "cost anomalies",
  },
  {
    path: "/all-clouds/anomalies",
    component: <Navbar />,
    outlet: <AllCloudCostAnomaly />,
    wrapper: AuthGuard,
    redirectToService: true,
    module: "cost anomalies",
  },
  {
    path: "/gcp/anomalies",
    component: <Navbar />,
    outlet: <GCPCostAnomaly />,
    wrapper: AuthGuard,
    redirectToService: true,
    module: "cost anomalies",
  },
  {
    path: "/aws/kubernetes",
    component: <Navbar />,
    outlet: <AwsKubernates />,
    wrapper: AuthGuard,
    redirectToService: true,
    module: "kubernetes",
  },

  {
    path: "/azure/kubernetes",
    component: <Navbar />,
    outlet: <AzureKubernates />,
    wrapper: AuthGuard,
    redirectToService: true,
    module: "kubernetes",
  },
  {
    path: "/all-clouds/kubernetes",
    component: <Navbar />,
    outlet: <AllCloudKubernates />,
    wrapper: AuthGuard,
    redirectToService: true,
    module: "kubernetes",
  },
  {
    path: "/gcp/kubernetes",
    component: <Navbar />,
    outlet: <OnWork />,
    wrapper: AuthGuard,
    redirectToService: true,
    module: "kubernetes",
  },

  {
    path: "/aws/reporting",
    component: <Navbar />,
    outlet: <AWSReporting/>,
    wrapper: AuthGuard,
  },

  {
    path: "/azure/reporting",
    component: <Navbar />,
    outlet: <AzureReporting/>,
    wrapper: AuthGuard,
  },
  {
    path: "/all-clouds/reporting",
    component: <Navbar />,
    outlet:<OnWorkallcloud/> ,
    wrapper: AuthGuard,
  },
  {
    path: "/gcp/reporting",
    component: <Navbar />,
    outlet: <GCPReporting/>,
    wrapper: AuthGuard,
  },
  {
    path: "/aws/virtual-tagging",
    component: <Navbar />,
    outlet: <AWSTagging />,
    wrapper: AuthGuard,
     module: "virtual tagging"
  },
  {
    path: "/azure/virtual-tagging",
    component: <Navbar />,
    outlet: <AzureTagging />,
    wrapper: AuthGuard,
    module: "virtual tagging"
  },
  {
    path: "/all-Clouds/virtual-tagging",
    component: <Navbar />,
    // outlet:<OnWorking name="Tagging" service="All Cloud" />,
    outlet: <Navigate to="/aws/virtual-tagging" />,
    wrapper: AuthGuard,
    module: "virtual tagging"
  },
  {
    path: "/gcp/virtual-tagging",
    component: <Navbar />,
    outlet: <GcpTagging />,
    wrapper: AuthGuard,
    module: "virtual tagging"
  },
  {
    path: "/admin",
    component: <AdminLayout />,
    outlet: <Roles />,
    wrapper: AuthGuardWithRole(ROLES.admin),
  },
  {
    path: "/admin/groups",
    component: <AdminLayout />,
    outlet: <Groups />,
    wrapper: AuthGuardWithRole(ROLES.admin),
  },
  {
    path: "/admin/users",
    component: <AdminLayout />,
    outlet: <Roles />,
    wrapper: AuthGuardWithRole(ROLES.admin),
  },
  {
    path: "/admin/privileges",
    component: <AdminLayout />,
    outlet: <Provisions />,
    wrapper: AuthGuardWithRole(ROLES.admin),
  },
   {
    path: "/admin/settings",
    component: <AdminLayout />,
    outlet: <SettingPage/>,
    wrapper: AuthGuardWithRole(ROLES.admin),
  },
  {
    path: "/profile",
    component: <Navbar />,
    outlet: <UserProfile />,
    wrapper: AuthGuard,
  },
  {
    path: "/aws/details",
    component: <Navbar />,
    outlet: <UsageDetailsComponent />,
    wrapper: AuthGuardWithRole(ROLES.admin),
  },
  {
    path: "/azure/details",
    component: <Navbar />,
    outlet: <UsageDetailsComponent />,
    wrapper: AuthGuardWithRole(ROLES.admin),
  },
  {
    path: "/gcp/details",
    component: <Navbar />,
    outlet: <UsageDetailsComponent />,
    wrapper: AuthGuardWithRole(ROLES.admin),
  },
  {
    path: "/all-clouds/ri-recommendations",
    component: <Navbar />,
    outlet: <Navigate to="/azure/ri-recommendations" replace={true} />,
    wrapper: AuthGuard,
    redirectToService: true,
  },
  {
    path: "/aws/ri-recommendations",
    component: <Navbar />,
    outlet: <OnWorking name="Ri-Recommendations" service="AWS" />,
    wrapper: AuthGuardWithRole(ROLES.admin),
  },
  {
    path: "/gcp/ri-recommendations",
    component: <Navbar />,
    outlet: <OnWork />,
    wrapper: AuthGuardWithRole(ROLES.admin),
  },
  {
    path: "/azure/ri-recommendations",
    component: <Navbar />,
    outlet: <AzureRiScreenComponent />,
    wrapper: AuthGuardWithRole(ROLES.admin),
  },
  {
    path: "/aws/search",
    component: <Navbar />,
    outlet: <SearchComponents service="aws" />,
    wrapper: AuthGuardWithRole(ROLES.admin),
  },
  {
    path: "/azure/search",
    component: <Navbar />,
    outlet: <SearchComponents service="azure" />,
    wrapper: AuthGuardWithRole(ROLES.admin),
  },
  {
    path: "/gcp/search",
    component: <Navbar />,
    outlet: <SearchComponents service="gcp" />,
    wrapper: AuthGuardWithRole(ROLES.admin),
  },
  {
    path: "/all-clouds/vm-disk-usage",
    component: <Navbar />,
    outlet: <Navigate to="/azure/vm-disk-usage" replace={true} />,
    wrapper: AuthGuard,
    redirectToService: true,
  },
  {
    path: "/aws/vm-disk-usage",
    component: <Navbar />,
    outlet: <OnWorking name="AI-Recommendations" service="AWS" />,
    // outlet: <AWSAiRecommendations/>,
    wrapper: AuthGuardWithRole(ROLES.admin),
  },
  {
    path: "/azure/vm-disk-usage",
    component: <Navbar />,
    outlet: <AzureAiRecommendations />,
    wrapper: AuthGuardWithRole(ROLES.admin),
  },
  {
    path: "/gcp/vm-disk-usage",
    component: <Navbar />,
    outlet: <OnWork />,
    wrapper: AuthGuardWithRole(ROLES.admin),
  },
  {
    path: "/azure/billing-credit",
    component: <Navbar />,
    outlet: <AzureBillingPage />,
    wrapper: AuthGuardWithRole(ROLES.admin),
    module: "credits"
  },
  {
    path: "/aws/billing-credit",
    component: <Navbar />,
    // outlet: <OnWorking name= "AWS Billing-Credit"/>,
    outlet: <AwsBillingPage />,
    wrapper: AuthGuardWithRole(ROLES.admin),
    module: "credits"
  },
  {
    path: "/all-clouds/billing-credit",
    component: <Navbar />,
    // outlet: <OnWorking name="Billing-Credit" service="All Cloud"/>,
    outlet: <AllCloudBillingPage />,
    wrapper: AuthGuardWithRole(ROLES.admin),
    module: "credits"
  },
  {
    path: "/gcp/billing-credit",
    component: <Navbar />,
    outlet: <GCPBillingPage />,
    wrapper: AuthGuardWithRole(ROLES.admin),
    module: "credits"
  },
  {
    path: "/aws/ri-utilization",
    component: <Navbar />,
    outlet: <AWSUtilizationSection />,
    wrapper: AuthGuard,
    redirectToService: true,
    module: "ri utilization"
  },
  {
    path: "/azure/ri-utilization",
    component: <Navbar />,
    outlet: <AzureRiUtilization />,
    // outlet: <OnWorking name="RI-utilization" service="AZURE" />,
    wrapper: AuthGuard,
    redirectToService: true,
    module: "ri utilization"
  },
  {
    path: "/all-clouds/ri-utilization",
    component: <Navbar />,
    outlet: <OnWorkallcloud />,
    wrapper: AuthGuard,
    redirectToService: true,
    module: "ri utilization"
  },
  {
    path: "/gcp/ri-utilization",
    component: <Navbar />,
    outlet: <OnWorking name="RI-utilization" service="GCP" />,
    wrapper: AuthGuard,
    redirectToService: true,
    module: "ri utilization"
  },
  {
    path: "/aws/recommendation",
    component: <Navbar />,
    outlet: <AwsRiScreenComponent />,
    wrapper: AuthGuard,
    redirectToService: true,
    module: "recommendations",
  },
  {
    path: "/all-clouds/recommendation",
    component: <Navbar />,
    outlet: <AllCloudRecommedationPage service="All-Cloud" />,
    wrapper: AuthGuard,
    redirectToService: true,
    module: "recommendations",
  },
  {
    path: "/gcp/recommendation",
    component: <Navbar />,
    outlet: <OnWorking name="Recommendations" service="GCP" />,
    wrapper: AuthGuard,
    redirectToService: true,
    module: "recommendations",
  },
  {
    path: "/azure/recommendation",
    component: <Navbar />,
    outlet: <AZureRiScreenComponent />,
    wrapper: AuthGuard,
    redirectToService: true,
    module: "recommendations",
  },
];

export default routesData;
